import { PortalBootResponse } from '@/lib/types';
import styled from 'styled-components';

import { cssObjectToString, type CssObject } from './cssObjectToString';

export type { CssObject } from './cssObjectToString';

export const StyledPortalHeader = styled.div<{
  header: PortalBootResponse['theme']['header'] | undefined;
  customCss?: CssObject;
  buttonColor: string;
}>`
  .portal-header {
    background: ${({ header }) => header?.backgroundColor?.colorOne || '#FFF'};
  }

  .player-name {
    color: ${({ header }) => header?.textColor || '#FFFFFF'};
    font-family: ${({ header }) => header?.playerIdFont || 'inherit'};
  }
  .player-id {
    color: ${({ header }) => header?.textColor || '#FFFFFF'};
    font-family: ${({ header }) => header?.playerIdFont || 'inherit'};
  }
  .login-button {
    border-radius: 6px;
    border: ${({ buttonColor }) => `0px solid ${buttonColor || 'transparent'}`};
    padding: 8px 16px;
    box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.3);
    background: ${({ header }) =>
      header?.loginButton?.backgroundColor?.colorOne ||
      'linear-gradient(to bottom, #EF9519, #FABF33)'};
    color: ${({ header }) => header?.textColor || '#FFFFFF'};
  }
  .balance-container {
    color: ${({ header }) => header?.textColor || '#FFFFFF'};
  }

  .avatar-container {
    width: 60px;
  }
  .avatar {
    position: relative;
    z-index: 1;
  }
  .player-frame {
    z-index: 0;
    width: 60px;
    height: 60px;
  }
  .header-logo {
    margin-right: 24px;
    height: 44px;
    width: auto;

    @media (max-width: 400px) {
      height: 30px;
      margin-right: 0px;
    }
  }

  ${({ customCss }) => cssObjectToString(customCss)}
`;
